'use client';

import { Info } from 'lucide-react';

const infoLabels: Record<string, string> = {
  nl: 'Meer informatie',
  en: 'More information',
  de: 'Weitere Informationen',
  fr: 'Plus d’informations',
};

/** Click activation works for touch and native keyboard activation alike.
 * Open the existing explanation dialog after release, never on hover/pointerdown.
 */
export function OptionInfoButton({
  title,
  locale,
  onOpen,
}: {
  title: string;
  locale: string;
  onOpen: () => void;
}) {
  return (
    <button
      type="button"
      aria-label={`${infoLabels[locale] || infoLabels.nl}: ${title}`}
      aria-haspopup="dialog"
      className="ml-1.5 inline-flex h-11 w-11 flex-none items-center justify-center rounded-full bg-gray-100 text-gray-500 transition hover:bg-gray-200 hover:text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
      onClick={(event) => {
        // The trigger can sit inside an option label. Do not activate its input.
        event.preventDefault();
        event.stopPropagation();
        onOpen();
      }}
    >
      <Info aria-hidden="true" className="h-4 w-4" />
    </button>
  );
}
